import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { HipaaDocumentsState } from './types';

export const initialState: HipaaDocumentsState = {
  isFetching: false,
  error: null,
  data: null
};

const hipaaDocuments = createReducer(initialState, {
  [actions.GET_DOCUMENTS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_DOCUMENTS_SUCCESS]: (state, action) => {
    if (state) state.isFetching = false;
    state.data = action.payload.data;
  },
  [actions.GET_DOCUMENTS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.data = null;
    state.error = action.error;
  },
  [actions.RESET_DOCUMENTS]: state => {
    state.isFetching = false;
    state.data = null;
    state.error = null;
  }
});

export default hipaaDocuments;
